var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container content-430 document-content"},[(_vm.showEditor)?_c('EditorV5',{ref:"editorV5",attrs:{"show-toolbar":false,"editor-config-for-props":{placeholder:'',readOnly:true}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }